import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from './middlewares/promiseMiddleware';
import analyticsMiddleware from './middlewares/analyticsMiddleware';
import notificationsMiddleware from './middlewares/notificationsMiddleware';
import reducer from './reducers';

export default initialState => {
  const storeCreator = (__DEV__ && __CLIENT__ && window.__REDUX_DEVTOOLS_EXTENSION__)
    ? compose(
      applyMiddleware(thunkMiddleware, promiseMiddleware, notificationsMiddleware, analyticsMiddleware),
      // window.devToolsExtension()
      window.__REDUX_DEVTOOLS_EXTENSION__(),
    )
    : compose(
      applyMiddleware(thunkMiddleware, promiseMiddleware, notificationsMiddleware, analyticsMiddleware)
    );
  return createStore(
    reducer,
    initialState,
    storeCreator
  );
};
